import { render } from "./AlertBox.vue?vue&type=template&id=3fed6719&scoped=true"
import script from "./AlertBox.vue?vue&type=script&lang=js"
export * from "./AlertBox.vue?vue&type=script&lang=js"

import "./AlertBox.vue?vue&type=style&index=0&id=3fed6719&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fed6719"]])

export default __exports__